import { gql } from '@apollo/client';
import { LOCATION_FIELDS } from '@/graphql/queries/locations';

export const GET_SELLABLE_SKUS = gql`
    query GetSellableSkus($client_id: uuid!) {
        forward_stocking_sku_by_carrier(
            where: { client_id: { _eq: $client_id }, on_hand_count: { _gt: 0 } }
            order_by: [{ sku: asc }, { carrier_name: asc }]
        ) {
            sku
            carrier_id
            carrier_name
            description
            on_hand_count
        }
    }
`;

export const GET_SELLABLE_SKU_ITEMS = gql`
    query GetSellableSkuItems($client_id: uuid!, $carrier_id: uuid!, $skus: [String!]!) {
        forward_stocking_items(
            where: {
                client_id: { _eq: $client_id }
                carrier_id: { _eq: $carrier_id }
                sku: { _in: $skus }
                status: { _eq: "ON_HAND" }
            }
            order_by: { received_into_warehouse_time: asc_nulls_last }
        ) {
            item_id
            carrier_id
            sku
            serialized
            received_into_warehouse_time
            dwell_days
            item {
                item_id
                serial_number
                line_id
            }
        }
    }
`;

export const GET_CARRIER_PICKUP_LOCATION = gql`
    query GetCarrierPickupLocation($carrier_id: uuid!) {
        locations(
            where: { client_id: { _eq: $carrier_id } }
            order_by: [{ preferred_inbound: desc_nulls_last }, { location_name: asc }]
        ) {
            ...LocationFields
        }
        clients(where: { client_id: { _eq: $carrier_id } }) {
            client_id
            business_phone
        }
    }
    ${LOCATION_FIELDS}
`;
